"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferTemplateType = void 0;
var OfferTemplateType;
(function (OfferTemplateType) {
    OfferTemplateType["BOOKING_SERVICE"] = "BOOKING_SERVICE";
    OfferTemplateType["CLICK_COLLECT"] = "CLICK_COLLECT";
    OfferTemplateType["TABLE_SERVICE"] = "TABLE_SERVICE";
})(OfferTemplateType = exports.OfferTemplateType || (exports.OfferTemplateType = {}));
